// RU-ROLL RL-15: the contract expiry of a futures / option position and the trading days left, from the backend's
// `expiry_info` ({last_trading_day, trading_days_left, level, kind}). Amber in the roll window (1-3 trading days
// left), red on the last trading day (and after it); nothing when the expiry is not known.

const LEVEL_CLASS = {
  roll_window: "text-amber-400 border-amber-500/50 bg-amber-500/10",
  last_day: "text-red-400 border-red-500/50 bg-red-500/10",
  expired: "text-red-400 border-red-500/50 bg-red-500/10",
};

export function expiryLevelClass(info) {
  return (info && LEVEL_CLASS[info.level]) || "txt-muted border-[var(--border)]";
}

const shortDate = (iso) => {
  const d = new Date(`${iso}T00:00:00Z`);
  return isNaN(d) ? iso : d.toLocaleDateString("en-IN", { timeZone: "UTC", day: "2-digit", month: "short" });
};

export function expiryText(info) {
  if (!info || !info.last_trading_day) return null;
  const when = shortDate(info.last_trading_day);
  if (info.level === "expired") return `${when} · expired`;
  if (info.level === "last_day") return `${when} · last day`;
  const n = info.trading_days_left;
  return `${when} · ${n}d left`;
}

export function expiryTitle(info) {
  if (!info || !info.last_trading_day) return undefined;
  const base = `Last trading day ${info.last_trading_day} · ${info.trading_days_left} trading day(s) left`;
  if (info.level === "roll_window") {
    return info.kind === "FUT" ? `${base} · paper futures are rolled to the next contract in this window`
      : `${base} · options are not rolled`;
  }
  if (info.level === "last_day") return `${base} · expires today`;
  if (info.level === "expired") return `${base} · the contract has expired`;
  return base;
}

export default function ExpiryBadge({ info, testid }) {
  const text = expiryText(info);
  if (!text) return null;
  return (
    <span
      className={`inline-block font-mono-data text-[10px] px-1 py-0.5 border whitespace-nowrap ${expiryLevelClass(info)}`}
      title={expiryTitle(info)}
      data-testid={testid}
      data-level={info.level}
    >
      {text}
    </span>
  );
}
